import React, { Component } from "react";
import Sidebar from "components/sidebar/Sidebar";
import Radium from "radium";
import dashboardRoutes from "routes/dashboardRoutes";
import Header from "components/header/Header";
//import Footer from "components/footer/Footer";
import themeActions from "redux/themeChanger/actions.js";
import settingactions from "redux/themeSettings/actions";
import AppLocale from "languageProvider";
import { drawerWidth, miniDrawerWidth } from "helper/constant";
import { Route, Switch } from "react-router-dom";
import { connect } from "react-redux";
import { IntlProvider } from "react-intl";
import { Scrollbars } from "react-custom-scrollbars";
import GlobalWrapper from "./global.style";
import { H_COMPONENTS, BREAKPOINT } from "../helper/constant";

//Notification
import "react-notifications/lib/notifications.css";
import { NotificationContainer } from "react-notifications";

import { withRouter } from "react-router-dom";
import RightSidebar from "../components/rightSidebar/RightSidebar";

import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faArrowCircleUp } from "@fortawesome/free-solid-svg-icons";
import { serverResponse } from "../util/fakeServer";
import "react-alice-carousel/lib/alice-carousel.css";
import { isMobile, isIE, isEdge, isIPad13 } from "react-device-detect";

import { Helmet } from "react-helmet";
import FloatingMenu from "../components/floatingMenu/FloatingMenu";
import Overlay from "../components/common/Overlay";
import { isSidebarRightOpen } from "../redux/carousel/action";
import ModalComponent from "../components/modal/ModalComponent";
import { gAInitializer } from "../helper/utility";
import ModalCartError from "../components/common/ModalCartError";
import ModalConfirmClearCart from "../components/common/ModalConfirmClearCart";
import ErrorModal from "../components/error/ErrorModal";
import * as services from "../services/search.services";

const { changeTheme } = themeActions;
const { sidebarMini } = settingactions;

class DashboardLayout extends Component {
  state = {
    mini: this.props.themeSetting.sidebarMiniValue
      ? this.props.themeSetting.sidebarMiniValue === "on"
      : false,
    themeDrawer: true,
    statedrawerWidth: drawerWidth,
    stateminiDrawerWidth: miniDrawerWidth,
    displaySearchResults: "none",
    filteredProducts: [],
    searchText: "",
    scrollTop: 0,
    h_browser_nav: 0,
    products: [],
    loading: 0,
    lastSearch: "",
    error: false,
    isMobileView: window.innerWidth < BREAKPOINT.lg
  };

  handleViewportResize = () => {
    const isMobileView = window.innerWidth < BREAKPOINT.lg;
    if (isMobileView !== this.state.isMobileView) {
      this.setState({ isMobileView });
    }
  };

  handleSearch = async () => {
    this.setState({
      loading: 1,
      displaySearchResults: "flex",
      lastSearch: this.state.searchText,
      filteredProducts: [],
      error: false
    });

    const serverData = {
      terms: this.state.searchText,
      leaflet_id: serverResponse.leaflet.id
    };

    // var formdata = new FormData();
    // formdata.append("terms", this.state.searchText); //"17488.12"
    // formdata.append(
    //   "interactive_flyer_id",
    //   JSON.stringify(serverResponse.leaflet.id)
    // );
    // formdata.append(
    //   "signboard_id",
    //   JSON.stringify(serverResponse.config.signboard_id)
    // );

    // var requestOptions = {
    //   method: "POST",
    //   body: formdata,
    //   redirect: "follow"
    // };

    // fetch(
    //   "https://dev02.interattivo.net/it/api/product-global-search-json",
    //   requestOptions
    // )
    //   .then((response) => response.json())
    //   .then((res) => {
    //     this.setState({
    //       filteredProducts: res.products,
    //       loading: 0
    //     });
    //   })
    //   .catch((error) => {
    //     this.setState({
    //       error: true,
    //       loading: 0
    //     });
    //   });

    try {
      const data = await services.getProductsSearchbar(serverData);

      if (data) {
        const {
          data: { data: response }
        } = data;
        this.setState({
          filteredProducts: response,
          loading: 0
        });
      }
    } catch (error) {
      console.log(
        "🚀 ~ file: DashboardLayout.jsx:126 ~ DashboardLayout ~ handleSearch= ~ error",
        error
      );

      this.setState({
        error: true,
        loading: 0
      });
    }
  };

  setDisplaySearchResults = (display) => {
    this.setState({
      displaySearchResults: display
    });
  };

  resetSearchBar = () => {
    this.setState({
      displaySearchResults: "none",
      filteredProducts: [],
      searchText: "",
      lastSearch: "",
      loading: false
    });
  };

  componentDidMount = () => {
    const actualHeight = window.innerHeight;

    const elementHeight = document.getElementById("control-height")
      .clientHeight;

    const barHeight = elementHeight - actualHeight;
    this.setState({ h_browser_nav: barHeight });

    window.addEventListener("resize", this.handleViewportResize);
  };

  componentWillUnmount = () => {
    window.removeEventListener("resize", this.handleViewportResize);
  };

  componentDidUpdate = (prevProps) => {
    if (this.props.location !== prevProps.location) {
      const { scrollbars } = this.refs;
      scrollbars.scrollTop(0);
      // this.setState({ displaySearchResults: "none", searchText: "" });
    }
  };

  componentWillReceiveProps = (nextprops) => {
    if (
      this.props.themeSetting.sidebarMiniValue !==
      nextprops.themeSetting.sidebarMiniValue
    ) {
      this.setState({
        mini: nextprops.themeSetting.sidebarMiniValue === "on"
      });
    }
  };

  componentWillMount = () => {
    gAInitializer();
    let tmpProducts = [];
    let tmp = Object.assign({}, serverResponse);

    tmp.leaflet.pages.forEach((page) => {
      tmpProducts = tmpProducts.concat(page.interactivities);
    });

    tmpProducts.sort((a, b) => {
      const [aID, bID] = [parseInt(a.item_id), parseInt(b.item_id)];
      if (aID === -1) return +1;
      if (bID === -1) return -1;
      return aID - bID;
    });

    this.setState({
      products: tmpProducts
    });
  };

  drawerMiniMethod = () => {
    if (this.state.mini) {
      this.setState({ mini: false });
      this.props.sidebarMini("off");
    } else {
      this.setState({ mini: true });
      this.props.sidebarMini("on");
    }
  };

  forceDrawerMini = () => {
    //console.log('drawer forced to mini', this.state.mini);
    this.setState({ mini: true });
    this.props.sidebarMini("on");
    this.props.isSidebarRightOpen(false);
  };

  themeSettingDrawer = () => {
    if (this.state.themeDrawer) {
      this.setState({ themeDrawer: false });
    } else {
      this.setState({ themeDrawer: true });
    }
  };

  mouseEnter = () => {
    if (this.state.mini) {
      this.setState({ stateminiDrawerWidth: drawerWidth });
    }
  };

  mouseLeave = () => {
    if (this.state.mini) {
      this.setState({ stateminiDrawerWidth: miniDrawerWidth });
    }
  };

  closeDrawer = () => {
    this.setState({ mini: true });
  };

  handleSearchTextChange = (e) => {
    this.setState({ searchText: e.target.value });
  };

  render() {
    // eslint-disable-next-line no-unused-vars
    let routeScrollHeight;
    const {
      mini,
      statedrawerWidth,
      stateminiDrawerWidth,
      showScrollTop
    } = this.state;
    const { layoutTheme, locale, themeSetting } = this.props;
    const currentAppLocale = AppLocale[locale];

    const showMobileSearch =
      this.state.isMobileView &&
      !serverResponse.config.hide_searchbar &&
      this.props.location.pathname !== "/categories";

    let routeArrowIcon = {
      backgroundColor: this.props.sidebarTheme.backgroundColor,
      color: this.props.sidebarTheme.textColor,
      borderBottomLeftRadius: 0,
      borderTopLeftRadius: 0,
      position: "fixed",
      zIndex: 1,
      fontSize: "18px",
      padding: "4px 5px"
    };

    if (
      themeSetting.toolbarDisplayValue === "hide" &&
      themeSetting.footerDisplayValue === "hide"
    ) {
      routeScrollHeight = {
        height: "calc(100vh - 0px)"
      };
    } else if (themeSetting.toolbarDisplayValue === "hide") {
      routeScrollHeight = {
        height: "calc(100vh - 51px)"
      };
    } else if (themeSetting.footerDisplayValue === "hide") {
      routeScrollHeight = {
        height: `calc(100vh - ${H_COMPONENTS.header}px)`,
        "@media (maxWidth: 767.98px)": {
          height: `calc(100vh - ${H_COMPONENTS.header}px)`
        }
      };
    } else {
      routeScrollHeight = {
        height: "calc(100vh - 116px)"
      };
    }

    const mainPanelWidth = {
      width: mini
        ? `calc(100% - ${miniDrawerWidth})`
        : `calc(100% - ${drawerWidth})`,
      backgroundColor: serverResponse.config.background_color,
      "@media (max-width: 991px)": {
        width: "100%"
      }
    };

    const routeHeightStyle = {
      marginRight: !this.props.sidebarRightOpen ? "50px" : "260px",
      transition: "all .15s linear",
      backgroundColor:
        serverResponse.config.background_color || layoutTheme.backgroundColor,
      "@media (max-width: 991px)": {
        margin: "0"
      }
    };

    return (
      <IntlProvider
        locale={currentAppLocale.locale}
        messages={currentAppLocale.messages}
      >
        <GlobalWrapper {...this.props}>
          <Sidebar
            openModal={false}
            setModal={this.setModal}
            mini={mini}
            drawerWidth={statedrawerWidth}
            miniDrawerWidth={stateminiDrawerWidth}
            onMouseEnter={this.mouseEnter}
            onMouseLeave={this.mouseLeave}
            closeDrawer={() => this.closeDrawer}
            forceDrawerMini={this.forceDrawerMini}
            themeMapping={this.props.themeMapping}
            {...this.props}
          />

          <Helmet>
            <title>{serverResponse.config.ogTitleMeta}</title>
            <meta
              property="og:title"
              content={serverResponse.config.ogTitleMeta}
            ></meta>
            <meta
              property="og:url"
              content={serverResponse.config.shareFlyerURL}
            ></meta>
            <meta
              property="og:description"
              content={serverResponse.config.ogDescriptionMeta}
            ></meta>
            <meta
              property="og:image"
              content={serverResponse.config.ogImageMeta}
            ></meta>
            <meta property="og:type" content="website"></meta>
          </Helmet>

          <RightSidebar themeMapping={this.props.themeMapping} />

          <div
            id="main-panel"
            className="main-panel"
            ref="mainPanel"
            style={[mainPanelWidth]}
          >
            {this.props.themeSetting.toolbarDisplayValue === "show" && (
              <Header
                lastSearch={this.state.lastSearch}
                loading={this.state.loading}
                setDisplaySearchResults={this.setDisplaySearchResults}
                drawerMiniMethod={() => this.drawerMiniMethod}
                mini={mini}
                resetSearchBar={this.resetSearchBar}
                drawerWidth={statedrawerWidth}
                miniDrawerWidth={stateminiDrawerWidth}
                {...this.props}
                displaySearchResults={this.state.displaySearchResults}
                handleSearch2={this.handleSearch}
                listFiltered={this.state.filteredProducts}
                searchText={this.state.searchText}
                handleSearchTextChange={this.handleSearchTextChange}
                error={this.state.error}
                showMobileSearch={showMobileSearch}
              />
            )}

            <div className="drawer-handle-arrow-hide-topbar">
              {themeSetting.toolbarDisplayValue !== "show" ? (
                mini ? (
                  <button
                    style={routeArrowIcon}
                    className="c-btn"
                    onClick={this.drawerMiniMethod}
                  >
                    <i className="fas fa-arrow-right" />
                  </button>
                ) : (
                  <button
                    style={routeArrowIcon}
                    className="c-btn"
                    onClick={this.drawerMiniMethod}
                  >
                    <i className="fas fa-arrow-left" />
                  </button>
                )
              ) : (
                ""
              )}
            </div>

            {themeSetting.toolbarDisplayValue !== "show" && (
              <button
                style={routeArrowIcon}
                className="c-btn mini-drawer-menu-icon-hide-topbar"
                onClick={this.drawerMiniMethod}
              >
                <i className="fas fa-bars" />
              </button>
            )}

            <div id="control-height"></div>
            <Scrollbars
              // style={routeScrollHeight}
              style={{
                height: `calc(100vh - ${H_COMPONENTS.header +
                  (isMobile || isIPad13 ? this.state.h_browser_nav : 0) +
                  (showMobileSearch ? H_COMPONENTS.mobile_searchbar : 0)}px)`
              }}
              autoHide
              ref="scrollbars"
              id="scrollbars"
              onScroll={(e) => {
                //this.setState({ scrollTop: e.target.scrollTop });
                if (e.target.scrollTop > 300) {
                  if (!this.state.showScrollTop) {
                    this.setState({
                      showScrollTop: true
                    });
                  }
                } else {
                  if (this.state.showScrollTop) {
                    this.setState({
                      showScrollTop: false
                    });
                  }
                }
              }}
            >
              {/* SearchBAR */}

              {/* Route Layout Start*/}
              <div
                className="route-height main p-0"
                style={[
                  routeHeightStyle,
                  {
                    height: "100%"
                  }
                ]}
              >
                <Switch>
                  <Route {...this.props}>
                    {dashboardRoutes.map((prop, key) => {
                      return (
                        <Route
                          path={prop.path}
                          render={(routeProps) => (
                            <prop.component
                              {...routeProps}
                              scrollTop={this.state.scrollTop}
                            />
                          )}
                          key={key}
                        />
                      );
                    })}
                  </Route>
                </Switch>
              </div>
              {/* Route Layout Finish*/}
            </Scrollbars>

            <FontAwesomeIcon
              size="3x"
              className="scroll-up-btn"
              style={showScrollTop ? { display: "block" } : { display: "none" }}
              icon={faArrowCircleUp}
              onClick={() => {
                if (isIE || isEdge) {
                  this.refs.scrollbars.view.scrollTop = 0;
                } else {
                  this.refs.scrollbars.view.scroll({
                    top: 0,
                    left: 0,
                    behavior: "smooth"
                  });
                }
              }}
            />
          </div>
          <NotificationContainer />
          {/* FLOATING BUTTON */}

          <FloatingMenu />

          {/* FINE FLOATING BUTTON */}
          <Overlay />
          {this.props.modalRedux.isModalOpen && <ModalComponent />}
          {this.props.cartReducer.modalCartError && <ModalCartError />}
          {this.props.cartReducer.modalConfirmClearCart && (
            <ModalConfirmClearCart />
          )}
          {this.props.errorReducer.modalErrorVisible && <ErrorModal />}
        </GlobalWrapper>
      </IntlProvider>
    );
  }
}

const mapStateToProps = (state) => {
  return {
    ...state.themeChanger,
    LanguageSwitcher: state.LanguageSwitcher,
    locale: state.LanguageSwitcher.language.locale,
    authData: {
      token: state.auth.accessToken,
      isLogin: state.auth.isLogin
    },
    themeSetting: {
      toolbarAlignValue: state.themeSetting.toolbarAlignValue,
      footerAlignValue: state.themeSetting.footerAlignValue,
      sidebarDisplayValue: state.themeSetting.sidebarDisplayValue,
      toolbarDisplayValue: state.themeSetting.toolbarDisplayValue,
      footerDisplayValue: state.themeSetting.footerDisplayValue,
      sidebarTransParentValue: state.themeSetting.sidebarTransParentValue,
      transparentImage: state.themeSetting.transparentImage,
      activeLinkStyle: state.themeSetting.activeLinkStyle,
      sidebarMiniValue: state.themeSetting.sidebarMiniValue,
      sidebarTransParentActiveBack:
        state.themeSetting.sidebarTransParentActiveBack,
      sidebarTransParentActiveColor:
        state.themeSetting.sidebarTransParentActiveColor
    },
    sidebarRightOpen: state.carousel.sidebarRightOpen,
    modalRedux: state.modal,
    cartReducer: state.cartReducer,
    errorReducer: state.errorReducer
  };
};

export default withRouter(
  connect(mapStateToProps, {
    changeTheme,
    sidebarMini,
    isSidebarRightOpen
  })(Radium(DashboardLayout))
);
